module.exports = __webpack_public_path__ + "media/images/lb/249-2f4e3a87c1828f6abfb078ccc3928a5e.svg";